module.exports = __webpack_public_path__ + "img/bg.56f4c3ea.png";